import { Map } from 'immutable'
import {
  SET_MENUS_DATA,
  CREATE_MENU_SUCCESS,
  SET_MENUS_PROCESSING,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_MENUS_PROCESSING: {
      const { processing } = payload
      return state.set('processing', processing)
    }
    case CREATE_MENU_SUCCESS:
      return state.update('data', (menuData) => menuData.unshift(payload.data))
        .set('processing', false)
    case SET_MENUS_DATA: {
      const { data = Map() } = payload
      return state.set('data', data)
        .set('processing', false)
    }
    default:
      return state
  }
}
